module.exports = __webpack_public_path__ + "img/earn-bnb.16f67670.svg";